<div mat-dialog-title color="primary" class="title">Do you really want to delete?</div>

<div mat-dialog-actions>
  <button mat-button class="button" (click)="cancel()">Cancel</button>
  <button mat-button class="verify-button" (click)="confirm()" cdkFocusInitial>Confirm</button>
</div>